import getSolutionById from "./getSolutionById";

const getSolutionTree = (solutionId, responseIds = [], parentSolutions = []) => {
  const solution = getSolutionById(solutionId);

  if (!solution) {
    return [];
  }

  const parentIds = parentSolutions.concat(solution).map(({ id }) => id);

  if (solution.diagnosticResponses && solution.diagnosticResponses.length > 0) {
    const childId = solution.diagnosticResponses.map(({ id }) => id).find(id => responseIds.includes(id));

    if (childId) {
      return getSolutionTree(childId, responseIds, parentSolutions.concat({ ...solution, childId, parentIds }));
    }

    return parentSolutions.concat({ ...solution, parentIds });
  }

  return parentSolutions.concat({ ...solution, hierarchyPosition: parentIds });
};

export default getSolutionTree;
